import { Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import { UseFormReturn } from "react-hook-form";
import { useCallback, useEffect } from "react";
import { ModalLoading } from "../../../../../../common/components/modal_loading";
import FormContainer from "../../../../../../common/components/form_container";
import PrimaryButton from "../../../../../../common/components/primary_button";
import { FormSwitchInput } from "../../../../../../common/components/masked_inputs/react_forms/form_switch_input";
import { SaldoBancarioCadastroForm } from "../../../schemas/SaldoBancario_cadastro/SaldoBancario_cadastro";
import { DefaultFormMoneyInput } from "../../../../../../common/components/default_form_money_input";

/**
 * CadastroSaldoBancario
 */

type Props = {
    open: boolean,
    saving: boolean,
    hookForm: UseFormReturn<SaldoBancarioCadastroForm>,
    onSubmit: (form: SaldoBancarioCadastroForm) => void,
    onClose: () => void,

};

export const CadastroSaldoBancarioModal = ({
    open,
    saving,
    hookForm,
    onSubmit,
    onClose,

}: Props) => {

    // usePageStartBootstrap(async () => {
    //     if (bancoPagamento) {
    //         hookForm.
    //     }
    // });

    useEffect(() => {
        if (open) {
            hookForm.setValue('cadastroMovimento', true);
        }
    }, [
        open,
        hookForm,
    ]);

    const handleSubmit = useCallback((form: SaldoBancarioCadastroForm) => {
        if (!saving)
            onSubmit(form);

    }, [saving, onSubmit]);

    const handleClose = useCallback(() => {
        if (!saving)
            onClose();

    }, [saving, onClose]);

    return (

        <Dialog
            open={open}
            slotProps={{
                paper: {
                    component: 'form',
                    onSubmit: hookForm.handleSubmit(handleSubmit),
                }
            }}
            sx={{
                "& .MuiDialog-container": {
                    "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "45rem",
                    },
                },
            }}>

            <DialogTitle>
                Cadastrar Movimento
            </DialogTitle>

            <DialogContent>
                <ModalLoading loading={saving}>
                    <FormContainer title={"Informações"} arrangement="fullRow">
                        <>
                            <div className="w-full bg-white p-4 rounded-2xl shadow-sm">
                                <div className="grid grid-cols-1 gap-4">
                                    <div className="flex items-center justify-between">
                                        <label className="font-medium text-gray-700">Tipo Movimento:</label>
                                        <FormSwitchInput
                                            name="tipo"
                                            activeLabel="Crédito"
                                            inactiveLabel="Débito"
                                            readOnly={saving}
                                            reactHookForm={hookForm}
                                        />
                                    </div>
                                </div>
                            </div>

                            <DefaultFormMoneyInput
                                name='valor'
                                label='Valor:'
                                required
                                readOnly={saving}
                                reactHookForm={hookForm}
                            />

                        </>
                    </FormContainer>
                </ModalLoading>
            </DialogContent>

            <DialogActions>
                <div className="w-full h-full items-end justify-end flex px-4 pb-4 gap-4">

                    <div className="flex flex-row gap-2">
                        <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
                            <h1
                                className="text-sm text-black dark:text-white"
                                onClick={handleClose}>
                                Cancelar
                            </h1>
                        </div>

                        <div className="w-[120px]">
                            {saving ? (
                                <PrimaryButton
                                    buttonColor="primary-green">
                                    Salvando...
                                </PrimaryButton>
                            ) : (
                                <PrimaryButton
                                    type="submit"
                                    buttonColor="primary-green">
                                    Salvar
                                </PrimaryButton>
                            )}
                        </div>
                    </div>
                </div>
            </DialogActions>
        </Dialog >
    );
}